module.exports = __webpack_public_path__ + "static/media/fish-farm.a546c484.PNG";